module.exports = {
    siteUrl: `https://kc.ayush4all.com`, // Site domain. Do not include a trailing slash!

    postsPerPage: 12, // Number of posts shown on paginated pages (changes this requires sometimes to delete the cache)

    siteTitleMeta: `AYUSH4ALL`, // This allows an alternative site title for meta data for pages.
    siteDescriptionMeta: `Single Point platform for everybody in AYUSH `, // This allows an alternative site description for meta data for pages.

    shareImageWidth: 1000, // Change to the width of your default share image
    shareImageHeight: 523, // Change to the height of your default share image

    shortTitle: `AYUSH4ALL`, // Used for App manifest e.g. Mobile Home Screen
    siteIcon: `favicon.png`, // Logo in /static dir used for SEO, RSS, and App manifest
    backgroundColor: `#ffffff`, // Used for Offline Manifest
    themeColor: `#ffffff`, // Used for Offline Manifest
}
